import { toast } from "react-toastify";
import { storeUser, getToken, clearUser } from "./storage";

export const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://rugdoctornzb2b.co.nz/api"
    // ? "https://rug.wekacreative.com/api" 
    : "http://localhost:8000/api";

export async function login({ username, password }) {
  simulateDelay();
  let response = await fetch(`${baseUrl}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  });

  if (!response.ok) {
    notify("Username or password incorrect.", "error");
    throw Error("error logging in");
  } else {
    let { user, token } = await response.json();
    storeUser(user, token);
    return response;
  }
}

export async function logout() {
  let token = await getToken();
  await fetch(`${baseUrl}/logout`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` }
  });
  await clearUser();
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function notify(message, type = "success") {
  toast[type](message, { position: toast.POSITION.TOP_CENTER });
}

export function responseToAsyncSelect(response, valueKey, labelKey, use_app) {
  return response.data.data.map(d => ({
    value: d[valueKey],
    label: d[labelKey],
    use_app : d[use_app]
  }));
}

export async function simulateDelay(length = 1000) {
  let action =
    process.env.NODE_ENV === "production" ? null : await delay(length);
  return action;
}



// WEBPACK FOOTER //
// ./src/backend/index.js